import React from "react";
import {
  Container,
  LabelContainer,
  LeftSection,
  RightSection,
  SummaryDataRowContainer,
  VerticalLine,
} from "./ReservedTimeSummaryTile.styles";
import UI from "@mile-meeting/mile-ui";
import ToolTip from "uis/new-tootip";
import { useRecoilValue } from "recoil";
import { workspace } from "recoil/recoilState";
import { TMeetingOverviewDashBoard } from "types/analytics.types";

type ReservedTimeSummaryTileProps = {
  data?: TMeetingOverviewDashBoard;
  disabled?: boolean; // Optional prop to disable the tile
};
const ReservedTimeSummaryTile: React.FC<ReservedTimeSummaryTileProps> = ({ data, disabled }) => {
  const workspaceInfo = useRecoilValue(workspace);
  return (
    <Container disabled={disabled}>
      <LeftSection>
        <LabelContainer>
          <UI.Typography
            type="body01 normal"
            color={disabled ? "var(--alias-color-label-disabled)" : "var(--alias-color-label-neutral)"}
          >
            확보한 여유 시간
          </UI.Typography>
          {disabled && <UI.Icon name="question" size={20} color="var(--alias-color-label-disabled)" />}
          {!disabled && (
            <ToolTip
              text={
                <p>
                  확보한 여유 시간은 조회 기간 동안 마일의 기능을 통해
                  <br />
                  {workspaceInfo?.name}이(가) 확보한 회의실 여유 시간을 의미합니다.
                </p>
              }
              position={{
                top: 28,
                left: -40,
              }}
            />
          )}
        </LabelContainer>
        <UI.Typography
          type="heading02"
          fontStyle="bold"
          color={disabled ? "var(--alias-color-label-disabled)" : "var(--alias-color-label-strong)"}
        >
          {data?.saveTime.totalSaveTime.toLocaleString() || "0"}시간
        </UI.Typography>
      </LeftSection>
      <VerticalLine />
      <RightSection>
        <SummaryDataRowContainer>
          <UI.Typography
            type="label01"
            fontStyle="regular"
            color={disabled ? "var(--alias-color-label-disabled)" : "var(--alias-color-label-neutral)"}
          >
            당일 회의실 이용 알림 내 바로 취소
          </UI.Typography>
          <UI.Typography
            type="body01 normal"
            color={disabled ? "var(--alias-color-label-disabled)" : "var(--alias-color-label-normal)"}
          >
            {data?.saveTime.saveTimeByConfirmAlarm.toLocaleString() || "0"}시간
          </UI.Typography>
        </SummaryDataRowContainer>
        <SummaryDataRowContainer>
          <UI.Typography
            type="label01"
            fontStyle="regular"
            color={disabled ? "var(--alias-color-label-disabled)" : "var(--alias-color-label-neutral)"}
          >
            회의 시작 전 알림 내 바로 취소
          </UI.Typography>
          <UI.Typography
            type="body01 normal"
            color={disabled ? "var(--alias-color-label-disabled)" : "var(--alias-color-label-normal)"}
          >
            {data?.saveTime.saveTimeByReminder.toLocaleString() || "0"}시간
          </UI.Typography>
        </SummaryDataRowContainer>
        <SummaryDataRowContainer>
          <UI.Typography
            type="label01"
            fontStyle="regular"
            color={disabled ? "var(--alias-color-label-disabled)" : "var(--alias-color-label-neutral)"}
          >
            노쇼 경고 알림 내 바로 취소
          </UI.Typography>
          <UI.Typography
            type="body01 normal"
            color={disabled ? "var(--alias-color-label-disabled)" : "var(--alias-color-label-normal)"}
          >
            {data?.saveTime.saveTimeByNoshowWarning.toLocaleString() || "0"}시간
          </UI.Typography>
        </SummaryDataRowContainer>
        <SummaryDataRowContainer>
          <UI.Typography
            type="label01"
            fontStyle="regular"
            color={disabled ? "var(--alias-color-label-disabled)" : "var(--alias-color-label-neutral)"}
          >
            회의 조기 종료(자동 체크아웃 포함)
          </UI.Typography>
          <UI.Typography
            type="body01 normal"
            color={disabled ? "var(--alias-color-label-disabled)" : "var(--alias-color-label-normal)"}
          >
            {data?.saveTime.saveTimeByFinish.toLocaleString() || "0"}시간
          </UI.Typography>
        </SummaryDataRowContainer>
      </RightSection>
      {/* !-----------------------! */}
      <RightSection>
        <SummaryDataRowContainer>
          <UI.Typography
            type="label01"
            fontStyle="regular"
            color={disabled ? "var(--alias-color-label-disabled)" : "var(--alias-color-label-neutral)"}
          >
            노쇼 취소
          </UI.Typography>
          <UI.Typography
            type="body01 normal"
            color={disabled ? "var(--alias-color-label-disabled)" : "var(--alias-color-label-normal)"}
          >
            {data?.saveTime.saveTimeByNoshow.toLocaleString() || "0"}시간
          </UI.Typography>
        </SummaryDataRowContainer>
        <SummaryDataRowContainer>
          <UI.Typography
            type="label01"
            fontStyle="regular"
            color={disabled ? "var(--alias-color-label-disabled)" : "var(--alias-color-label-neutral)"}
          >
            반복 예약 취소 기능으로 취소*
          </UI.Typography>
          <UI.Typography
            type="body01 normal"
            color={disabled ? "var(--alias-color-label-disabled)" : "var(--alias-color-label-normal)"}
          >
            {data?.saveTime.saveTimeByCancellationRecurring.toLocaleString() || "0"}시간
          </UI.Typography>
        </SummaryDataRowContainer>
        <SummaryDataRowContainer>
          <UI.Typography
            type="label01"
            fontStyle="regular"
            color={disabled ? "var(--alias-color-label-disabled)" : "var(--alias-color-label-neutral)"}
          >
            반복 예약 취소 요청 알림 내 취소*
          </UI.Typography>
          <UI.Typography
            type="body01 normal"
            color={disabled ? "var(--alias-color-label-disabled)" : "var(--alias-color-label-normal)"}
          >
            {data?.saveTime.saveTimeByRequestCancellationRecurring.toLocaleString() || "0"}시간
          </UI.Typography>
        </SummaryDataRowContainer>
        <UI.Typography
          type="caption01"
          fontStyle="regular"
          color={disabled ? "var(--alias-color-label-disabled)" : "var(--alias-color-label-alternative)"}
        >
          * 반복 예약 취소 기능 또는 반복 예약 취소 요청 기능을 통해 확보한 여유 시간은 최대 1년 기간으로 집계됩니다.
        </UI.Typography>
      </RightSection>
    </Container>
  );
};
export default React.memo(ReservedTimeSummaryTile);
